export * from './category-not-found';

import { CategoryNotFoundMessageTemplateComponent } from './category-not-found';

export const CategoryMessageComponents = [
    CategoryNotFoundMessageTemplateComponent,
];
